<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
const MainLayout = defineAsyncComponent(
  () => import('@/layouts/MainLayout.vue'),
)
const PublicLayout = defineAsyncComponent(
  () => import('@/layouts/PublicLayout.vue'),
)
const route = useRoute()

const LayoutComponent = computed(() =>
  route.meta.layout === 'public' ? PublicLayout : MainLayout,
)
</script>

<template>
  <component :is="LayoutComponent" />
  <DevShowBreakpoint />
</template>
